import { companyClient } from "../clients/companyClient"
import type {
  CompanyResponseDto,
  UpdateCompanyDto,
  CompanyListParams,
  AllocateCreditsDto,
  AllocateCreditsResponseDto,
} from "../types/company.types"

/**
 * Company Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const companyService = {
  /**
   * Get company by slug
   */
  getCompanyBySlug: async (slug: string): Promise<CompanyResponseDto> => {
    try {
      const company = await companyClient.getCompanyBySlug(slug)
      return company
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List companies (Admin only, optional search by name)
   * Returns array directly (not paginated)
   */
  getCompanies: async (params?: CompanyListParams): Promise<CompanyResponseDto[]> => {
    try {
      const companies = await companyClient.getCompanies(params)
      return companies
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update company by slug
   * Admin: can update verified companies (all fields)
   * Owner: can update company & contact fields only
   */
  updateCompany: async (
    slug: string,
    data: UpdateCompanyDto
  ): Promise<CompanyResponseDto> => {
    try {
      const company = await companyClient.updateCompany(slug, data)
      return company
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Allocate credits and/or ad quotas to a company (Admin only)
   */
  allocateCredits: async (
    slug: string,
    data: AllocateCreditsDto
  ): Promise<AllocateCreditsResponseDto> => {
    try {
      const response = await companyClient.allocateCredits(slug, data)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default companyService

